angular.module('rental')
.component('rentalAgreementAnnexes', {
    bindings: {
        agreementId: '<',
        agreementUid: '<'
    },
    templateUrl: 'app/rental/agreement/rental-agreement-annexes.html',
    controller: function ($scope, $state, RentalAgreementConst, RentalAgreement, RentalAgreementService) {
        this.RentalAgreementService = RentalAgreementService

        this.$onChanges = () => {
            this.itemsPromise = RentalAgreement.annexes({id: this.agreementId}).$promise.then(result => this.items = result)
        }
        this.add = () => {
            let tmp = {
                parent: { id: this.agreementId, uid: this.agreementUid }
            }
            RentalAgreementService.add(tmp)
        }

        $scope.$on(RentalAgreementConst.eventUpdate, () => this.$onChanges())
    }
})
